import React, { useEffect, useRef, useState } from 'react';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  from?: 'up' | 'left';
  as?: 'div' | 'article' | 'section';
}
export function Reveal({
  children,
  className = '',
  delay = 0,
  from = 'up',
  as: Tag = 'div'
}: RevealProps) {
  const ref = useRef<HTMLElement | null>(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof IntersectionObserver === 'undefined') {
      setShown(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setShown(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '0px 0px -8% 0px'
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  const hidden = from === 'left' ? '-translate-x-3.5 opacity-0' : 'translate-y-4 opacity-0';
  return (
    // @ts-expect-error dynamic tag ref typing
    <Tag ref={ref} style={{
      transitionDelay: `${delay}ms`
    }} className={`transition-[opacity,transform] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none ${shown ? 'translate-x-0 translate-y-0 opacity-100' : hidden} ${className}`} data-id="element-197" data-mp="2c44v3vsom0u7">
      {children}
    </Tag>
  );
}